import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Footer from "../component/Footer";
import axios from "axios";
import copy from "copy-to-clipboard";
import MessageToster from "../component/MessageToster";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../api";
import { fetchRealAccounts } from "../hooks/useRealAccounts";
import { getApiHeaders } from "../utils/helpers";
import { useHandleError } from "../hooks/useHandleError";
import Loader from "../component/Loader";
import { useSearchParams } from "react-router-dom";
import { QRCodeCanvas } from 'qrcode.react';
import CommonTable from '../component/CommonTable';

export default function DepositTether() {
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const handleError = useHandleError();
  const [searchParams] = useSearchParams();
  const mid = Number(sessionStorage.getItem("mid"));
  // const mid = Number(25);
  // const COIN_TYPE = "TRC20 USDT";
  const COIN_TYPE = searchParams.get("coin") || "";
  const selectedPaymentMethod = `Tether (${COIN_TYPE})`;
  // const walletId = "SFX27840";
  const [walletAddress, setWalletAddress] = useState("");
  const [loading, setLoading] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [walletDetail, setWalletDetail] = useState([]);

  const [formData, setFormData] = useState({
    paymentMethod: selectedPaymentMethod,
    accountInput: "",
    amount: "",
    transactionHash: "",
    receiptFile: null,
  });
  const [paymentProcess, setPaymentProcess] = useState("account");
  // const [currency, setCurrency] = useState("USD");

  const [validations, setValidations] = useState({
    account: "",
    amount: "",
    transactionHash: "",
    receiptFile: "",
  });

  const [copied, setCopied] = useState(false);

  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      paymentMethod: `Tether (${COIN_TYPE})`
    }));
  }, [COIN_TYPE]);

  // const copytext = (text) => {
  //   copy(text);
  //   MessageToster("success", "Wallet address copied! ");
  // };

  const copytext = (text) => {
    copy(text);
    setCopied(true);
    MessageToster("success", "Wallet address copied!");

    // Reset back to copy icon after 2 sec
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  useEffect(() => {
    fetchAddress();
  }, []);

  const fetchAddress = async () => {
    setLoading(true);

    // const inputBody = {
    //   // mid: Number(mid),
    //   cointype: COIN_TYPE
    // }

    const inputBody = COIN_TYPE;

    try {
      const res = await axios.post(`${BASE_URL}/deposit/check_address`, inputBody, { headers: getApiHeaders() });
      // const res = await axios.post(`http://192.168.29.119:8001/deposit/check_address`, inputBody);

      const address = res?.data?.data?.[0]?.[0]?.Address;

      if (!address) {
        await generateAddress();
      } else {
        setWalletAddress(address);
      }

    } catch (err) {
      console.log(err);
      handleError(err)
    } finally {
      setLoading(false);
    }
  };

  const generateAddress = async () => {
    try {
      const inputBody = { cointype: COIN_TYPE, mode: "" };
      // const inputBody = { mid, cointype: COIN_TYPE, mode: "" };

      const res = await axios.post(`${BASE_URL}/deposit/insert_address`, inputBody, { headers: getApiHeaders() });
      // const res = await axios.post(`http://192.168.29.119:8001/deposit/insert_address`, inputBody);

      if (res.data?.code === 200) {
        const inserAddress = res?.data?.data?.[0]?.[0]?.Address;

        setWalletAddress(inserAddress);
        // setWalletAddress(res.data.address);
      }
    } catch (err) {
      console.log("Insert address error", err);
      if (err.response && err.response.status === 400) {
        MessageToster("error", err.response.data?.detail || "Please Try Again");
        navigate("/deposit");
      } else {
        handleError(err)
      }
    }
  };

  const getWalletData = async () => {
    setLoading(true);

    // const bodyData = {
    //   mode: "",
    //   mid: mid
    // };

    const bodyData = {};

    try {
      const res = await axios.post(`${BASE_URL}/my_wallet/ewallet_id_balance`, bodyData, { headers: getApiHeaders() });

      if (res.data.code === 200) {
        setWalletDetail(res.data.data);
      } else {
        MessageToster("error", res.data.message || "Something went wrong");
      }

    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getWalletData();
  }, []);

  const walletId = walletDetail?.walletid;

  const updateField = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));

    setValidations(prev => ({
      ...prev,
      [field]: ""
    }));

  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let errors = {};

    if (!formData.amount) {
      errors.amount = "Amount is required";
    }
    if (!formData.transactionHash) {
      errors.transactionHash = "Transaction hash is required";
    }
    if (!formData.receiptFile) {
      errors.receiptFile = "Receipt file is required";
    }

    setValidations(errors);

    if (Object.keys(errors).length > 0) {
      return;
    }

    await submitTransectionData();
  };

  const submitTransectionData = async () => {
    setLoading(true);
    try {

      const accountType = paymentProcess === "account" ? "MT5" : "EWallet";

      const form = new FormData();
      form.append("mid", Number(mid));
      form.append("payment_method", formData.paymentMethod);
      form.append("account", formData.accountInput);
      form.append("amount", formData.amount);
      form.append("transaction_hash", formData.transactionHash);
      form.append("account_type", accountType);
      if (formData.receiptFile) {
        form.append("deposit_receipt", formData.receiptFile);
      }

      const res = await axios.post(`${BASE_URL}/deposit/user_transaction_data_receipt`, form, { headers: getApiHeaders(true) });

      if (res.data.code === 200) {
        MessageToster("success", "Deposit submitted successfully!");

        setFormData({
          paymentMethod: "Tether USD (USDT TRC20)",
          // accountInput: "",
          amount: "",
          transactionHash: "",
          receiptFile: null,
        });

        setValidations({
          // account: "",
          amount: "",
          transactionHash: "",
          receiptFile: "",
        });

        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }

      } else {
        MessageToster("error", res.data.message || "Something went wrong");
      }

    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getAllAccounts();
  }, []);

  const getAllAccounts = async () => {
    // const inputBody = {};
    // const inputBody = { mid: Number(mid), mode: "" };
    try {
      setLoading(true);
      const res = await fetchRealAccounts();

      if (res.data.code === 200) {
        setAccounts(res.data.data || []);
      } else {
        MessageToster("error", res.data.message || "Failed to fetch accounts");
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const getCoinImage = (coin) => {
    switch (coin) {
      case "BEP20 USDT":
        return "/assets/images/deposit/Tether_BEP20_USDT.svg";
      case "TRC20 USDT":
        return "/assets/images/deposit/Tether_TRC20_USDT.svg";
      default:
        return "/assets/images/deposit/Tether.svg";
    }
  };

  return (
    <>
      <div id="layout-wrapper">
        {loading &&
          <Loader />
        }
        <Topbar />
        <Sidebar />
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              {/* start page title */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h2 className="fw-700 mb-sm-0">Deposit</h2>
                  </div>
                </div>
              </div>
              {/* end page title */}
              <div className="row justify-content-center">
                {/* <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="">
                        <ul
                          className="nav nav-pills bg-light rounded transfer_tab"
                          role="tablist"
                        >
                          <li className="nav-item">
                            <a
                              className="nav-link active"
                              data-bs-toggle="tab"
                              href="#transfer_details"
                              role="tab"
                            >
                              Transfer Details
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className="nav-link"
                              data-bs-toggle="tab"
                              href="#confirm_Transfer"
                              role="tab"
                            >
                              Confirm Transfer
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div> */}
                <>
                  <div className="row mt-4">
                    {/* <div className="col-xl-7 col-lg-12">
                      <div className="card">
                        <div className="card-body">
                          <h4 className="card-title mb-4">Transfer Details</h4>
                          <div className="row">
                            <div className="col-12 mb-4">
                              <div className="hstack justify-content-between gap-2 flex-wrap">
                                <img
                                  // src="assets/images/deposit/Tether.svg"
                                  src={getCoinImage(COIN_TYPE)}
                                  alt="product-img"
                                  width={50}
                                />
                                <button
                                  type="button"
                                  className="btn btn-primary px-3"
                                  onClick={() => navigate("/deposit")}
                                >
                                  Change Payment Method
                                </button>
                              </div>
                            </div>

                            <div className="col-lg-12 mb-3">
                              <div className="gap-3 align-items-center flex-wrap mb-0">
                                <div className="">
                                  <label className="form-label mb-3">
                                    Payment Process{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="d-flex gap-3 ms-3">
                                  <div className="form-check form-check-inline">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="payment_process"
                                      id="radioAccount"
                                      defaultValue="option2"
                                      checked={paymentProcess === "account"}
                                      onChange={() => setPaymentProcess("account")}
                                    // onChange={() => {
                                    //   setPaymentProcess("account");
                                    //   updateField("accountInput", "");  // optional
                                    // }}

                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="radioAccount"
                                    >
                                      Account
                                    </label>
                                  </div>
                                  <div className="form-check form-check-inline">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="payment_process"
                                      id="radioWallet"
                                      defaultValue="option2"
                                      checked={paymentProcess === "wallet"}
                                      onChange={() => {
                                        setPaymentProcess("wallet");
                                        updateField("accountInput", walletId);
                                      }

                                      }
                                    // disabled
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="radioWallet"
                                    >
                                      Wallet
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6 mb-3">
                              <div className="gap-3 align-items-center">
                                <div className="">
                                  <label className="form-label mb-3">
                                    Currency{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="form-check form-check-inline ms-3">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name=""
                                    id="radioCurrency"
                                    defaultValue="option2"
                                    defaultChecked={true}
                                  />
                                  <label
                                    className="form-check-label notranslate"
                                    htmlFor="radioCurrency"
                                    translate="no"
                                  >
                                    USDT
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-12 mb-4">
                              <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      Payment Method <span className="text-danger">*</span>
                                    </label>

                                    <input
                                      type="text"
                                      className="form-control"
                                      value={formData.paymentMethod}
                                      disabled
                                    />
                                  </div>

                                </div>
                                {paymentProcess === "account" && (
                                  <div className="mb-3">
                                    <label className="form-label">
                                      Account

                                    </label>
                                    <select className="form-select" name="select"
                                      value={formData.accountInput}
                                      onChange={(e) => updateField("accountInput", e.target.value)}
                                    >
                                      <option value="" disabled hidden> Select account number</option>
                                      {accounts.length > 0 ? (
                                        accounts.map((acc, index) => (
                                          <option key={index} value={acc}>
                                            {acc}
                                          </option>
                                        ))
                                      ) : (
                                        <option>No account found</option>
                                      )}
                                    </select>

                                  </div>
                                )}
                                {paymentProcess === "wallet" && (
                                  <div className="mb-3">
                                    <label className="form-label">Wallet ID</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      // value={"SFX27840"}
                                      value={formData.accountInput}
                                      disabled
                                    />
                                  </div>
                                )}
                                <div className="mb-3">
                                  <label className="form-label" id="">
                                    Amount (In USD){" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    placeholder="Amount (In USD)"
                                    name=""
                                    id=""
                                    value={formData.amount}
                                    onChange={(e) => updateField("amount", e.target.value)}
                                  />
                                  {validations.amount && (
                                    <p className="text-danger">{validations.amount}</p>
                                  )}
                                </div>
                                <div className="mb-3">
                                  <label className="form-label">
                                    Transaction Hash{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    placeholder="Transaction Hash"
                                    value={formData.transactionHash}
                                    onChange={(e) => updateField("transactionHash", e.target.value)}
                                  />
                                  {validations.transactionHash && (
                                    <p className="text-danger">{validations.transactionHash}</p>
                                  )}
                                </div>
                                <div className="mb-3">
                                  <label className="form-label">
                                    Deposit Receipt{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    className="form-control"
                                    type="file"
                                    id="formFile"
                                    ref={fileInputRef}
                                    // value={formData.receiptFile}
                                    onChange={(e) => updateField("receiptFile", e.target.files[0])}
                                  />
                                  {validations.receiptFile && (
                                    <p className="text-danger">{validations.receiptFile}</p>
                                  )}
                                  <p className="mt-1 text-primary">
                                    File Supported jpeg, jpg, png, pdf &amp; max
                                    file size : 5MB
                                  </p>
                                </div>
                                <div className="mb-3">
                                  <button
                                    type="submit"
                                    className="btn btn-primary px-4"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}

                    {/* RIGHT SIDE – OTHER DETAILS */}

                    {/* <div className="col-lg-12">
                     
                      <div className="card">
                        <div className="card-body">

                          <div className="p-3">
                            <div className="row">
                              <div className="col-md-6 border-end">

                                <h4 className="card-title text-primary pb-2 border-bottom">
                                  QR Code
                                </h4>

                                {loading ? (
                                  <p>Loading QR...</p>
                                ) : !walletAddress ? (
                                  <img
                                    src="assets/images/qr_img.png"
                                    alt="qr"
                                    width={300}
                                    className="qr_img mb-3"
                                  />
                                ) : (
                                  <QRCodeCanvas
                                    value={walletAddress}
                                    size={300}
                                    marginSize={4}
                                    className="qr_img mb-3"
                                  />
                                )}

                                <h4 className="card-title text-primary pb-2 border-bottom">
                                  Wallet Address
                                </h4>

                                <div className="referral_box">
                                  <div className="d-flex justify-content-between align-items-center p-2 gap-2">
                                    <p className="fs-5 text-dark mb-0 wallet-address-text">

                                      {loading ? "Loading..." : (walletAddress ?? "No Address Available")}
                                    </p>

                                    <button
                                      className="btn bg-primary text-white px-3"
                                      // onClick={() => copytext(walletAddress)}
                                      onClick={() => walletAddress && copytext(walletAddress)}
                                      disabled={!walletAddress}
                                    >
                                      <i className="bx bx-copy fs-4"></i>
                                    </button>
                                  </div>
                                </div>


                              </div>

                              <div className="col-md-6">

                                <div className="col-12 mb-4">
                                  <div className="hstack justify-content-between gap-2 flex-wrap">
                                    <img
                                      // src="assets/images/deposit/Tether.svg"
                                      src={getCoinImage(COIN_TYPE)}
                                      alt="product-img"
                                      width={50}
                                    />
                                    <button
                                      type="button"
                                      className="btn btn-primary px-3"
                                      onClick={() => navigate("/deposit")}
                                    >
                                      Change Payment Method
                                    </button>
                                  </div>
                                </div>

                                <div className="d-flex gap-3 align-items-center border-bottom pb-2 mb-3 mt-3">
                                  <h4 className="card-title text-primary mb-0">
                                    Wallet Currency:
                                  </h4>
                                  <span className="badge badge-soft-success fs-5 notranslate" translate="no">
                                    USDT
                                  </span>
                                </div>

                                <h4 className="card-title mb-2">
                                  Transfer Details
                                </h4>
                                <div className="table-responsive">
                                  <CommonTable 
                                    hideHeader={true}
                                    tableClassName="table border align-middle mb-0 table-nowrap"
                                    columns={[
                                      { accessor: 'label', render: (row) => <th>{row.label}</th> },
                                      { accessor: 'value', className: "bg-light-subtle" }
                                    ]}
                                    data={[
                                      { label: "Commission", value: "0.00%" },
                                      { label: "Deposit Processing Time", value: "1 Hour" },
                                      { label: "Currency", value: "USD" },
                                      { label: "Minimum Withdrawal", value: "10" },
                                      { label: "Maximum Withdrawal", value: "100000" }
                                    ]}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}

                    <div className="col-lg-12">
                      <div className="card shadow-sm border-0" style={{ borderRadius: "15px" }}>
                        <div className="card-body p-4">
                          <div className="row g-4">

                            {/* Left Column: QR & Address */}
                            <div className="col-md-5 text-center border-end">
                              <div className="mb-4">
                                <h5 className="text-muted fw-bold text-uppercase mb-3" style={{ letterSpacing: '1px' }}>
                                  Scan QR Code
                                </h5>
                                <div className="d-inline-block p-3 bg-light rounded-4 shadow-sm mb-3">
                                  {loading ? (
                                    <div className="d-flex align-items-center justify-content-center" style={{ width: 220, height: 220 }}>
                                      <div className="spinner-border text-primary" role="status"></div>
                                    </div>
                                  ) : !walletAddress ? (
                                    <div
                                      className="d-flex flex-column align-items-center justify-content-center text-danger"
                                      style={{
                                        width: 220,
                                        height: 220,
                                        border: "2px dashed #ec822b",
                                        borderRadius: "12px",
                                        background: "#fffaf5"
                                      }}
                                    >
                                      <i className="bx bx-error-circle mb-2" style={{ fontSize: "28px" }}></i>
                                      <p className="mb-0 small fw-semibold text-center">
                                        Wallet address not available
                                      </p>
                                      <p className="mb-0 small text-center">
                                        Please try again later
                                      </p>
                                    </div>
                                    // <img src="assets/images/qr_img.png" alt="qr" width={220} className="rounded" />
                                  ) : (
                                    <QRCodeCanvas value={walletAddress} size={220} marginSize={1} />
                                  )}
                                </div>
                              </div>

                              <div className="px-3">
                                <label className="form-label text-muted fw-semibold" style={{ fontSize: "1.0rem" }}>Wallet Address</label>
                                <div className="input-group mb-2 shadow-sm rounded-3 overflow-hidden">
                                  <input
                                    type="text"
                                    className={`form-control border-0 py-2 px-3 font-monospace ${!walletAddress ? "bg-light text-muted" : "bg-white text-dark"
                                      }`}
                                    value={
                                      loading
                                        ? "Loading..."
                                        : walletAddress
                                          ? walletAddress
                                          : ""
                                    }
                                    placeholder={!loading && !walletAddress ? "Wallet address not available" : ""}
                                    readOnly
                                    style={{ fontSize: '0.9rem' }}
                                  />
                                  {/* <input
                                    type="text"
                                    className="form-control border-0 bg-light py-2 px-3 font-monospace"
                                    value={loading ? "Loading..." : (walletAddress ?? "No Address")}
                                    readOnly
                                    style={{ fontSize: '0.9rem' }}
                                  /> */}
                                  {/* <button
                                    className="btn btn-primary px-3"
                                    onClick={() => walletAddress && copytext(walletAddress)}
                                    disabled={!walletAddress}
                                  >
                                    <i className="bx bx-copy"></i>
                                  </button> */}
                                  {/* <button
                                    className="btn btn-primary px-3"
                                    onClick={() => walletAddress && copytext(walletAddress)}
                                    disabled={!walletAddress || loading}
                                    title={!walletAddress ? "No address to copy" : "Copy address"}
                                  >
                                    <i className="bx bx-copy"></i>
                                  </button> */}

                                  <button
                                    className={`btn px-3 ${copied ? "btn-success" : "btn-primary"
                                      }`}
                                    style={{ transition: "all 0.3s ease" }}
                                    onClick={() => walletAddress && copytext(walletAddress)}
                                    disabled={!walletAddress || loading}
                                    title={!walletAddress ? "No address to copy" : "Copy address"}
                                  >
                                    <i className={`bx ${copied ? "bx-check" : "bx-copy"}`}></i>
                                  </button>
                                </div>
                                <p className="text-danger small mt-2">
                                  <i className="bx bx-info-circle me-1"></i>
                                  Only send <strong className="notranslate" translate="no">USDT</strong> to this address.
                                </p>
                              </div>
                            </div>

                            {/* Right Column: Details & Action */}
                            <div className="col-md-7 ps-md-5">
                              <div className="d-flex justify-content-between align-items-center mb-4">
                                <div className="d-flex align-items-center gap-3">
                                  <div className="p-2 bg-soft-success rounded-circle">
                                    <img src={getCoinImage(COIN_TYPE)} alt="coin" width={40} />
                                  </div>
                                  <div>
                                    <h4 className="mb-0 fw-bold notranslate" translate="no">Deposit USDT</h4>
                                    <span className="badge rounded-pill bg-success-subtle text-success border border-success-subtle notranslate" translate="no" style={{ fontSize: '0.8rem' }}>
                                      {/* TRC20 Network */}
                                      {COIN_TYPE.split(" ")[0]} Network
                                    </span>
                                  </div>
                                </div>
                                <button
                                  type="button"
                                  className="btn btn-outline-primary btn-md rounded-pill px-3"
                                  onClick={() => navigate("/deposit")}
                                >
                                  Change Method
                                </button>
                              </div>

                              <div className="bg-light p-4 rounded-4">
                                <h6 className="fw-bold mb-3">Transaction Details</h6>

                                <div className="d-flex justify-content-between py-2 border-bottom border-2 border-white">
                                  <span className="text-muted">Commission</span>
                                  <span className="fw-bold text-success">0.00%</span>
                                </div>

                                <div className="d-flex justify-content-between py-2 border-bottom border-2 border-white">
                                  <span className="text-muted">Processing Time</span>
                                  <span className="fw-bold">~ 1 Hour</span>
                                </div>

                                {/* <div className="d-flex justify-content-between py-2 border-bottom border-2 border-white">
                                  <span className="text-muted">Currency</span>
                                  <span className="fw-bold">USD</span>
                                </div> */}

                                <div className="d-flex justify-content-between py-2 border-bottom border-2 border-white">
                                  <span className="text-muted">Minimum Deposit</span>
                                  <span className="fw-bold">10 USD</span>
                                </div>

                                <div className="d-flex justify-content-between py-2">
                                  <span className="text-muted">Maximum Limit</span>
                                  <span className="fw-bold">100,000 USD</span>
                                </div>
                              </div>

                              <div className="mt-4 p-3 border border-warning border-dashed rounded-3 bg-warning-subtle">
                                <small className="text-dark">
                                  <strong>Notice:</strong> Deposits are credited after 12 network confirmations. Please ensure the network matches or funds may be lost.
                                </small>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <div className="col-xl-5 col-lg-12">
                      <div className="card">
                        <div className="card-body">

                          <div className="p-3">

                            <h4 className="card-title text-primary pb-2 border-bottom">
                              QR Code
                            </h4>

                            {loading ? (
                              <p>Loading QR...</p>
                            ) : !walletAddress ? (
                              <img
                                src="assets/images/qr_img.png"
                                alt="qr"
                                width={300}
                                className="qr_img mb-3"
                              />
                            ) : (
                              <QRCodeCanvas
                                value={walletAddress}
                                size={300}
                                marginSize={4}
                                className="qr_img mb-3"
                              />
                            )}

                            <h4 className="card-title text-primary pb-2 border-bottom">
                              Wallet Address
                            </h4>

                            <div className="referral_box">
                              <div className="d-flex justify-content-between align-items-center p-2 gap-2">
                                <p className="fs-5 text-dark mb-0 wallet-address-text">
                                 
                                  {loading ? "Loading..." : (walletAddress ?? "No Address Available")}
                                </p>
                               
                                <button
                                  className="btn bg-primary text-white px-3"
                                  // onClick={() => copytext(walletAddress)}
                                  onClick={() => walletAddress && copytext(walletAddress)}
                                  disabled={!walletAddress}
                                >
                                  <i className="bx bx-copy fs-4"></i>
                                </button>
                              </div>
                            </div>

                            <div className="d-flex gap-3 align-items-center border-bottom pb-2 mb-3 mt-3">
                              <h4 className="card-title text-primary mb-0">
                                Wallet Currency:
                              </h4>
                              <span className="badge badge-soft-success fs-5 notranslate" translate="no">
                                USDT
                              </span>
                            </div>

                            <h4 className="card-title mb-2">
                              Transfer Details
                            </h4>
                            <div className="table-responsive">
                              <table className="table border align-middle mb-0 table-nowrap">
                                <tbody>
                                  <tr>
                                    <th>Commission</th>
                                    <td className="bg-light-subtle">0.00%</td>
                                  </tr>
                                  <tr>
                                    <th>Deposit Processing Time</th>
                                    <td className="bg-light-subtle">
                                      1 Hour
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Currency</th>
                                    <td className="bg-light-subtle">USD</td>
                                  </tr>
                                  <tr>
                                    <th>Minimum Withdrawal</th>
                                    <td className="bg-light-subtle">10</td>
                                  </tr>
                                  <tr>
                                    <th>Maximum Withdrawal</th>
                                    <td className="bg-light-subtle">100000</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </>
              </div>
            </div>
            {/* container-fluid */}
          </div>
          {/* End Page-content */}
          <Footer />
        </div>
      </div >
    </>
  );
}

// ===============================================================
// import React from "react";
// import { Link } from "react-router-dom";
// import Sidebar from "../component/Sidebar";
// import Topbar from "../component/Topbar";
// import Footer from "../component/Footer";

// export default function DepositTether() {
//   return (
//     <>
//       <div id="layout-wrapper">
//         <Topbar />
//         <Sidebar />
//         <div className="main-content">
//           <div className="page-content">
//             <div className="container-fluid">
//               <div className="row">
//                 <div className="col-12">
//                   <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                     <h2 className="fw-700 mb-sm-0">Deposit</h2>
//                   </div>
//                 </div>
//               </div>
//               <div className="row justify-content-center">
//                 <div className="col-12">
//                   <div className="card">
//                     <div className="card-body">
//                       <div className="">
//                         <ul
//                           className="nav nav-pills bg-light rounded transfer_tab"
//                           role="tablist"
//                         >
//                           <li className="nav-item">
//                             <a
//                               className="nav-link active"
//                               data-bs-toggle="tab"
//                               href="#transfer_details"
//                               role="tab"
//                             >
//                               Transfer Details
//                             </a>
//                           </li>
//                           <li className="nav-item">
//                             <a
//                               className="nav-link"
//                               data-bs-toggle="tab"
//                               href="#confirm_Transfer"
//                               role="tab"
//                             >
//                               Confirm Transfer
//                             </a>
//                           </li>
//                         </ul>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-12">
//                   <div className="card">
//                     <div className="card-body">
//                       <div className="tab-content mt-4">
//                         <div
//                           className="tab-pane active"
//                           id="transfer_details"
//                           role="tabpanel"
//                         >
//                           <div className="row">
//                             <div className="col-12 mb-3">
//                               <div className="hstack justify-content-between gap-2 flex-wrap flex-wrap">
//                                 <img
//                                   src="assets/images/deposit/Tether.svg"
//                                   alt="product-img"
//                                   title="product-img"
//                                   width={50}
//                                 />
//                                 <button
//                                   type="Submit"
//                                   className="btn btn-primary px-2 px-md-4"
//                                 >
//                                   Change Payment Method
//                                 </button>
//                               </div>
//                             </div>
//                             <div className="col-lg-12 mb-4">
//                               <div className="d-flex gap-3 align-items-center flex-wrap">
//                                 <div className="text-primary">
//                                   <h4 className="card-title mb-0">
//                                     Payment Process{" "}
//                                     <span className="text-danger">*</span>
//                                   </h4>
//                                 </div>
//                                 <div className="form-check form-check-inline">
//                                   <input
//                                     className="form-check-input"
//                                     type="radio"
//                                     name=""
//                                     id="inlineRadio2"
//                                     defaultValue="option2"
//                                     defaultChecked=""
//                                   />
//                                   <label
//                                     className="form-check-label"
//                                     htmlFor="inlineRadio2"
//                                   >
//                                     Account
//                                   </label>
//                                 </div>
//                                 <div className="form-check form-check-inline">
//                                   <input
//                                     className="form-check-input"
//                                     type="radio"
//                                     name=""
//                                     id="inlineRadio2"
//                                     defaultValue="option2"
//                                   />
//                                   <label
//                                     className="form-check-label"
//                                     htmlFor="inlineRadio2"
//                                   >
//                                     Wallet
//                                   </label>
//                                 </div>
//                               </div>
//                               <div className="d-flex gap-3 mt-3 align-items-center">
//                                 <div className="text-primary">
//                                   <h4 className="card-title mb-0">
//                                     Currency{" "}
//                                     <span className="text-danger">*</span>
//                                   </h4>
//                                 </div>
//                                 <div className="form-check form-check-inline">
//                                   <input
//                                     className="form-check-input"
//                                     type="radio"
//                                     name=""
//                                     id="inlineRadio2"
//                                     defaultValue="option2"
//                                     defaultChecked=""
//                                   />
//                                   <label
//                                     className="form-check-label"
//                                     htmlFor="inlineRadio2"
//                                   >
//                                     USD
//                                   </label>
//                                 </div>
//                               </div>

//                             </div>
//                             <div className="col-xl-6 col-lg-12 mb-3">
//                               <div>
//                                 <label className="form-label">
//                                   Payment Method{" "}
//                                   <span className="text-danger">*</span>
//                                 </label>
//                                 <select className="form-select" name="select">
//                                   <option value="Tether USD (USDT TRC20)">
//                                     Tether USD (USDT TRC20)
//                                   </option>
//                                   <option value="Wallet">Wallet</option>
//                                 </select>
//                               </div>
//                             </div>
//                             <div className="col-xl-6 mb-3">
//                               <div>
//                                 <label className="form-label">
//                                   Account <span className="text-danger">*</span>
//                                 </label>
//                                 <select className="form-select" name="select">
//                                   <option value="91020(USD)">91020</option>
//                                   <option value="91020(USD)">91020</option>
//                                 </select>
//                               </div>
//                             </div>
//                             <div className="col-xl-6 mb-3">
//                               <div>
//                                 <label className="form-label" id="">
//                                   Amount (In USD){" "}
//                                   <span className="text-danger">*</span>
//                                 </label>
//                                 <input
//                                   className="form-control"
//                                   type="text"
//                                   placeholder="Amount (In USD)"
//                                   name=""
//                                   id=""
//                                 />
//                               </div>
//                             </div>
//                             <div className="col-xl-6 mb-3">
//                               <div>
//                                 <label className="form-label">
//                                   Transaction Hash{" "}
//                                   <span className="text-danger">*</span>
//                                 </label>
//                                 <input
//                                   className="form-control"
//                                   type="text"
//                                   placeholder="Transaction Hash"
//                                 />
//                               </div>
//                             </div>
//                             <div className="col-xl-6 mb-3">
//                               <div>
//                                 <label className="form-label">
//                                   Deposit Receipt{" "}
//                                   <span className="text-danger">*</span>
//                                 </label>
//                                 <input
//                                   className="form-control"
//                                   type="file"
//                                   id="formFile"
//                                 />
//                                 <p className="mt-1 text-primary">
//                                   File Supported jpeg, jpg, png, pdf &amp; max
//                                   file size : 5MB
//                                 </p>
//                               </div>
//                             </div>
//                             <div className="col-12 mb-3">
//                               <button
//                                 type="Submit"
//                                 className="btn btn-primary px-4"
//                               >
//                                 Submit
//                               </button>
//                             </div>
//                           </div>
//                         </div>
//                         <div
//                           className="tab-pane"
//                           id="confirm_Transfer"
//                           role="tabpanel"
//                         >

//                           <div className="col-12">
//                             <div className="row g-4">
//                               <div className="col-xl-6">
//                                 <h4 className="card-title mb-4">
//                                   Other Details
//                                 </h4>
//                                 <div className="p-3">
//                                   <h4 className="card-title text-primary pb-2 border-bottom">
//                                     QR code
//                                   </h4>
//                                   <img
//                                     src="assets/images/qr_img.png"
//                                     alt=""
//                                     width={300}
//                                     className="qr_img"
//                                   />
//                                   <h4 className="card-title text-primary pb-2 border-bottom">
//                                     Wallet Address
//                                   </h4>
//                                   <div className="referral_box">
//                                     <div className="d-flex justify-content-between align-items-center p-2">
//                                       <p className="fs-5 text-dark txt-ellipsis-1 mb-0">
//                                         <span id="textToCopy">
//                                           TsbwlptbMwxZrBXPFkT4CBGZVRgd7YPU
//                                         </span>
//                                       </p>
//                                       <button
//                                         className="btn bg-primary rounded-2 px-3  border-none text-white"
//                                         id="copyButton"
//                                         type="button"
//                                       >
//                                         <i className="bx bx-copy fs-4 mt-1" />
//                                       </button>
//                                     </div>
//                                   </div>
//                                   <div className="d-flex gap-3 align-items-center">
//                                     <h4 className="card-title text-primary pb-0 mb-0">
//                                       Wallet Currency:{" "}
//                                     </h4>
//                                     <span className="badge badge-soft-success fs-5">
//                                       USD
//                                     </span>
//                                   </div>
//                                 </div>
//                               </div>
//                               <div className="col-xl-6">
//                                 <h4 className="card-title mb-4">
//                                   Transfer Details
//                                 </h4>
//                                 <div className="table-responsive">
//                                   <table className="table border align-middle mb-0 table-nowrap">
//                                     <tbody>
//                                       <tr>
//                                         <th>Commission</th>
//                                         <td className="bg-light-subtle"></td>
//                                       </tr>
//                                       <tr>
//                                         <th>Deposit Processing Time</th>
//                                         <td className="bg-light-subtle">
//                                           24 Hours
//                                         </td>
//                                       </tr>
//                                       <tr>
//                                         <th>Currencies</th>
//                                         <td className="bg-light-subtle">USD</td>
//                                       </tr>
//                                       <tr>
//                                         <th>Minimum Withdrawal</th>
//                                         <td className="bg-light-subtle">10</td>
//                                       </tr>
//                                       <tr>
//                                         <th>Maximum Withdrawal</th>
//                                         <td className="bg-light-subtle">
//                                           100000
//                                         </td>
//                                       </tr>
//                                     </tbody>
//                                   </table>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>

//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <Footer />
//         </div>
//       </div>
//     </>
//   );
// }
